import React from 'react';
import { LayoutDashboard, FileText, History, ClipboardPlus } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export default function DashboardSidebar() {
  const location = useLocation();
  
  const menuItems = [
    { 
      icon: <LayoutDashboard className="w-5 h-5" />, 
      label: 'Dashboard', 
      path: '/dashboard',
    },
    { 
      icon: <ClipboardPlus className="w-5 h-5" />,
      label: 'Reports', 
      path: '/dashboard/reports',
    },
    { 
      icon: <FileText className="w-5 h-5" />,
      label: 'Resources', 
      path: '/dashboard/resources',
    },
    { 
      icon: <History className="w-5 h-5" />, 
      label: 'Purchase History', 
      path: '/dashboard/purchases',
    },
];

  return (
    <aside className="fixed left-0 top-16 w-64 h-[calc(100vh-4rem)] border-r border-gray-200" style={{ backgroundColor: '#F8F8F7' }}>
      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}